import InvoiceIndex from './InvoiceIndex.vue';

export default InvoiceIndex;
